export class Range {
  constructor(x, y) {
    this.position = {
      x: x,
      y: y
    };
  }

}